<mat-icon svgIcon="search_off" matTooltip="{{ 'clearFilters' | translate }}" (click)="clearAllFilter()"></mat-icon>